import {
  CalendarClock,
  CalendarDays,
  CalendarRange,
  ChevronDown,
  ChevronsUp,
  Circle,
  CircleCheck,
  CircleDot,
  CircleX,
  GanttChart,
  KanbanSquare,
  List,
  LucideIcon,
  Minus,
  Sunrise,
  TriangleAlert,
  User,
  Users,
} from 'lucide-react';

/**
 * Иконки трекера задач (ТЗ 0064) — одно место на все экраны доски.
 *
 * ⚠️ Имена сверены с УСТАНОВЛЕННОЙ версией `lucide-react` (пин 0.577.0):
 * несуществующее имя даёт ошибку сборки, которой `tsc` не видит, а часть
 * иконок в 1.x переименована (`CheckCircle` → `CircleCheck`).
 *
 * Иконка всегда идёт РЯДОМ с подписью, а не вместо неё — кроме переключателя
 * видов, где подпись живёт в `title`. Там, где иконка дублирует и без того
 * ясное слово (девять строк селекта сортировки, название задачи, каждая
 * дата), её нет намеренно: она не помогает, а мешает сканировать.
 */
export const VIEW_ICONS: Record<string, LucideIcon> = {
  time: CalendarClock,
  status: KanbanSquare,
  gantt: GanttChart,
  calendar: CalendarDays,
  list: List,
};

export const MODE_ICONS: Record<string, LucideIcon> = {
  mine: User,
  team: Users,
};

export const STATUS_ICONS: Record<string, LucideIcon> = {
  open: Circle,
  in_progress: CircleDot,
  done: CircleCheck,
  cancelled: CircleX,
};

export const PRIORITY_ICONS: Record<string, LucideIcon> = {
  high: ChevronsUp,
  normal: Minus,
  low: ChevronDown,
};

/** Колонки доски сроков.
 *
 * ⚠️ Ключи обязаны совпадать с `COLUMNS` в `taskBuckets` буква в букву. Здесь
 * стояло `week`, а колонка называется `thisWeek` — и «На неделе» оказалась
 * единственной шапкой из пяти без иконки. Ни `tsc`, ни сборка такого не видят:
 * промах по ключу словаря — это `undefined`, а не ошибка. Ниже стоит тест,
 * сверяющий два списка. */
export const BUCKET_ICONS: Record<string, LucideIcon> = {
  overdue: TriangleAlert,
  today: CalendarDays,
  tomorrow: Sunrise,
  thisWeek: CalendarRange,
  later: CalendarClock,
};
